import { createAction } from 'redux-actions';

import { wrapFetch } from './endpoint';

export const getBanner = createAction('FETCH_BANNER', async (lan, hotel, page) => {
	const { status, message, data: { pic,pic_thumbnail } } = await wrapFetch(
		`api/v1/web/${lan}/${hotel}/banner/${page}`,
		{
			method: 'GET',
		},
	);

	if (status !== 200) {
		throw new Error(message);
	}

	return { image: pic, thumbnail: pic_thumbnail };
});



// WEBPACK FOOTER //
// ./src/actions/banner.js